import { Box } from '@mui/material'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ContactusImage from '../../assets/images/ContactHeader.webp'

const ContactusBgLanding = () => {
  return (
    <Box sx={{
      width: "100%",
      paddingTop: { xs: '6rem', sm: '5rem' },
    }} >
      <Box sx={{
        height: { xs: "8rem", sm: "initial" },
        width: '100%',
        overflow: 'hidden',
      }} >
        <LazyLoadImage
          src={ContactusImage}
          effect="blur"
          width="100%"
          height="100%"
          style={{ objectFit: 'cover' }}
        />
      </Box>
    </Box>
  )
}

export default ContactusBgLanding
